/*
  Clarity → Shopify order attribution.

  Writes the Microsoft Clarity user id (_clck) and session id (_clsk) onto the
  cart as note attributes, so they land on the resulting order under
  "Additional details" (next to tbId, cartToken, fbp, ...). That lets support
  paste the id straight into Clarity's user-id filter to find the exact session,
  instead of guessing by country/time.

  Consent: the _clck cookie only exists once Clarity has loaded (i.e. the
  visitor consented to it). No cookie -> we write nothing. So this is
  consent-gated by construction, with no separate consent check needed.

  Timing: we write EARLY (on add-to-cart and on the cart page), never at the
  final checkout click, so a slow POST can't be outrun by the navigation to
  /checkout. A per-session guard keeps it to a single cart call unless the
  session id rotates.
*/
(function () {
  // First segment of a Clarity cookie, or ''. Clarity delimits segments with a
  // caret (url-encoded as %5E), e.g. _clck = "1xbddgb^2^g7p^1^2385" -> id is
  // "1xbddgb". We split on ^ (and | as a fallback for older formats).
  function clarityCookie(name) {
    var match = document.cookie.match('(?:^|; )' + name + '=([^;]+)');
    return match ? decodeURIComponent(match[1]).split(/[\^|]/)[0] : '';
  }

  function writeAttributes() {
    var userId = clarityCookie('_clck');
    if (!userId) return; // no Clarity cookie = no consent / not loaded -> skip.

    var sessionId = clarityCookie('_clsk');
    var signature = userId + '|' + sessionId;

    // Already written for this exact (user, session) pair this tab session.
    if (sessionStorage.getItem('clarityOrderAttr') === signature) return;

    var updateUrl = (window.routes && window.routes.cart_update_url) || '/cart/update.js';
    fetch(updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { clarityUserId: userId, claritySessionId: sessionId },
      }),
    })
      .then(function () {
        try {
          sessionStorage.setItem('clarityOrderAttr', signature);
        } catch (e) {
          /* private mode / storage disabled — harmless, we'll just retry */
        }
      })
      .catch(function () {
        /* network hiccup — a later trigger will retry */
      });
  }

  // 1) Any classic add-to-cart form submit (Dawn product forms).
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      var action = (form && form.getAttribute && form.getAttribute('action')) || '';
      if (action.indexOf('/cart/add') !== -1) writeAttributes();
    },
    true
  );

  // 2) Fetch-based adds in this theme dispatch a 'cart:refresh' event
  //    (starterset builder, cart drawer). Covers the Starterset flow.
  document.documentElement.addEventListener('cart:refresh', writeAttributes);

  // 3) On the cart page, write on load so it's set before any checkout button.
  var cartPath = (window.routes && window.routes.cart_url) || '/cart';
  if (location.pathname === cartPath || location.pathname === '/cart') {
    if (document.readyState !== 'loading') writeAttributes();
    else document.addEventListener('DOMContentLoaded', writeAttributes);
  }

  // 4) Best-effort catch-all: first interaction with any checkout button.
  //    (Usually redundant with 1-3, but covers edge checkout entry points.)
  document.addEventListener(
    'click',
    function (event) {
      var t = event.target;
      if (
        t &&
        t.closest &&
        t.closest('[name="checkout"], [href$="/checkout"], .shopify-payment-button')
      ) {
        writeAttributes();
      }
    },
    true
  );
})();
